import { twMerge } from 'tailwind-merge'

export function CellText(props: { className?: string; text: string }) {
  return (
    <div className={twMerge('text-neutral-900 text-sm', props.className)}>
      {props.text}
    </div>
  )
}
